import { render, staticRenderFns } from "./MagicTable.vue?vue&type=template&id=2947985d&"
import script from "./MagicTable.vue?vue&type=script&lang=js&"
export * from "./MagicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports